/**
 * NSM site Footer — all content from config/site.js. UTF-8: Düsseldorf, Bahnstraße, ©.
 */
import React from "react";
import { Link } from "react-router-dom";
import { TicketLink } from "../elements/TicketLink";
import { site } from "../../config/site";

export default function Footer() {
  return (
    <footer className="site-footer site-footer--nsm">
      <div className="site-footer__top">
        <div className="container">
          <div className="site-footer__top-inner">
            <div className="site-footer__logo">
              <Link to="/"><span className="site-footer-logo-text nsm-footer-brand">NEXT SUPER MODEL</span></Link>
            </div>
            <div className="site-footer__social footer-social">
              <a href={site.instagramUrl} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="icon-instagram" /></a>
              <a href={site.facebookUrl} target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="icon-facebook" /></a>
            </div>
          </div>
        </div>
      </div>

      <div className="site-footer__middle">
        <div className="container">
          <div className="site-footer__middle-inner">
            <div className="row">
              <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="100ms">
                <div className="footer-widget__column footer-widget__events">
                  <div className="footer-widget__title-box"><h3 className="footer-widget__title">Event Info</h3></div>
                  <ul className="footer-widget__events-list list-unstyled">
                    <li>
                      <p>{site.eventYear} — {site.venueCityCountry}</p>
                      <h5>NSM — {site.venueName}</h5>
                      <TicketLink>
                        {site.ctaFooter} <span className="icon-arrow-right"></span>
                      </TicketLink>
                    </li>
                    <li>
                      <p>{site.venueName}, {site.venueAddress}</p>
                      <h5>Dress: {site.dressCode}</h5>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="200ms">
                <div className="footer-widget__column footer-widget__link">
                  <div className="footer-widget__title-box"><h3 className="footer-widget__title">Quick Links</h3></div>
                  <ul className="footer-widget__link-list list-unstyled">
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/gallery">Gallery</Link></li>
                    <li><Link to="/contact">Contact</Link></li>
                    <li><Link to="/terms">Terms &amp; Conditions</Link></li>
                    <li><Link to="/privacy">Privacy Policy</Link></li>
                  </ul>
                </div>
              </div>

              <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="300ms">
                <div className="footer-widget__column footer-widget__contact">
                  <div className="footer-widget__title-box"><h3 className="footer-widget__title">Contact</h3></div>
                  <div className="footer-widget__contact-inner">
                    <ul className="footer-widget__contact-list list-unstyled">
                      <li>
                        <div className="icon"><span className="icon-envelop"></span></div>
                        <div className="text"><p><a href={`mailto:${site.contactEmail}`}>{site.contactEmail}</a></p></div>
                      </li>
                      <li>
                        <div className="icon"><span className="icon-pin"></span></div>
                        <div className="text"><p>{site.companyAddress}</p></div>
                      </li>
                      <li>
                        <div className="icon"><span className="icon-call"></span></div>
                        <div className="text"><p><a href={`tel:${site.contactPhoneTel}`}>{site.contactPhone}</a></p></div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="site-footer__bottom">
        <div className="container">
          <div className="site-footer__bottom-inner bottom-grid">
            <p className="site-footer__bottom-text">© NEXT SUPER MODEL 2026 | All Rights Reserved</p>
            <ul className="list-unstyled site-footer__bottom-menu">
              <li><Link to="/terms">Terms &amp; Conditions</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
